import { api2  } from './ApiService';

export default class TopupGameService {
    
    static async search(key,page,perpage,start_date,end_date,status) {
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage,
            startDate: start_date,
            endDate: end_date,
            status: status
        }
        let response =  await api2.post(`/api/v1/topup/game/search`,data)
        return response.data
    }

}


// WEBPACK FOOTER //
// ./src/service/TopupGameService.js